import { ValidatedInput } from '@cp-shared-19/frontend-ui';
import React from 'react';

type TextProps = {
    label: string;
    name: string;
    placeholder?: string;
    isMandatory?: boolean;
    inputId?: string;
    defaultValue?: string;
    disabled?: boolean;
};

export const TextInput: React.FC<TextProps> = ({
    label,
    name,
    placeholder,
    isMandatory = true,
    inputId,
    defaultValue,
    disabled,
}) => {
    return (
        <ValidatedInput
            className="c-form-field--no-floating"
            label={label}
            aria-required={isMandatory}
            isMandatory={isMandatory}
            name={name}
            inputMode={'text'}
            testId={`test-${name}`}
            inputId={inputId}
            placeholder={placeholder}
            maxLength={40}
            defaultValue={defaultValue}
            disabled={disabled}
            requiredText=" *"
        />
    );
};
